"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleInterstitialState = exports.handleUnknownState = exports.authenticateRequest = void 0;
const backend_1 = require("@clerk/backend");
const server_1 = require("next/server");
const clerkClient_1 = require("./clerkClient");
const utils_1 = require("./utils");
const withClerkMiddleware_1 = require("./withClerkMiddleware");
const authenticateRequest = async (req, opts) => {
    const cookieToken = (0, utils_1.getCookie)(req, backend_1.constants.Cookies.Session);
    const headers = req.headers;
    const headerToken = headers.get('authorization')?.replace('Bearer ', '');
    return await clerkClient_1.clerkClient.authenticateRequest({
        ...opts,
        apiKey: opts.apiKey || clerkClient_1.API_KEY,
        secretKey: opts.secretKey || clerkClient_1.SECRET_KEY,
        frontendApi: opts.frontendApi || clerkClient_1.FRONTEND_API,
        publishableKey: opts.publishableKey || clerkClient_1.PUBLISHABLE_KEY,
        cookieToken,
        headerToken,
        clientUat: (0, utils_1.getCookie)(req, backend_1.constants.Cookies.ClientUat),
        origin: headers.get('origin') || undefined,
        host: headers.get('host'),
        forwardedPort: headers.get('x-forwarded-port') || undefined,
        forwardedHost: headers.get('x-forwarded-host') || undefined,
        referrer: headers.get('referer') || undefined,
        userAgent: headers.get('user-agent') || undefined,
        searchParams: new URL(req.url).searchParams,
    });
};
exports.authenticateRequest = authenticateRequest;
const handleUnknownState = (requestState) => {
    const response = new server_1.NextResponse(null, { status: 401, headers: { 'Content-Type': 'text/html' } });
    (0, withClerkMiddleware_1.decorateResponseWithObservabilityHeaders)(response, requestState);
    return response;
};
exports.handleUnknownState = handleUnknownState;
const handleInterstitialState = (requestState, opts) => {
    const response = new server_1.NextResponse(clerkClient_1.clerkClient.localInterstitial({
        frontendApi: opts.frontendApi || clerkClient_1.FRONTEND_API,
        publishableKey: opts.publishableKey || clerkClient_1.PUBLISHABLE_KEY,
        pkgVersion: clerkClient_1.JS_VERSION,
        proxyUrl: requestState.proxyUrl,
        isSatellite: requestState.isSatellite,
        domain: requestState.domain,
        debugData: (0, clerkClient_1.debugRequestState)(requestState),
        signInUrl: requestState.signInUrl,
    }), {
        status: 401,
        headers: {
            'content-type': 'text/html',
        },
    });
    (0, withClerkMiddleware_1.decorateResponseWithObservabilityHeaders)(response, requestState);
    return response;
};
exports.handleInterstitialState = handleInterstitialState;
